import { api } from 'shared/api'

import { ZapierSchemas } from './schemas'

export const ZapierAPI = {
  fetchZaps: api.account.createGet({
    url: '/zapierEvents/list',
    schemas: ZapierSchemas.fetchZaps,
  }),
  createZap: api.account.createGet({
    url: '/zapierEvents/create',
    schemas: ZapierSchemas.createZap,
  }),
}
